import * as React from 'react';
import classNames from 'classnames';
import { InvitaeIcon } from '../../../common/Icon/InvitaeIcon.esm.js';
import { NvMarkdownInline, NvHeading, NvMarkdown } from '@invitae/ids-react';
import styles from './ListWithIconBulletsSectionItem.module.esm.js';

var List = function (_a) {
    var _b = _a.fields, heading = _b.heading, body = _b.body, icon = _b.icon, _c = _a.classes, classes = _c === void 0 ? {} : _c;
    return (React.createElement("div", { className: classNames(styles.listItemContainer, classes.root) },
        icon && React.createElement(InvitaeIcon, { iconName: icon, nonDsm: true, size: "extraSmall" }),
        React.createElement("div", { className: styles.listItemTextContainer },
            React.createElement(NvMarkdownInline, { element: "h3", elementWrapper: NvHeading, level: 3 }, heading),
            React.createElement(NvMarkdown, null, body))));
};

export { List as default };
//# sourceMappingURL=ListWithIconBulletsSectionItem.esm.js.map
